import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash-es';
import { SubSink } from 'subsink';
import { AccountService } from '../services/account.service';
import { AuthenticationService } from '../services/authentication.service';
import { LoggingService } from '../services/logging.service';
import { BusinessOperation } from '../shared/models/business-operation';
import { UpdateAccountViewModel, UpdatePasswordViewModel } from '../shared/models/update-account-view-model';
import { ToastService } from '../shared/toast/toast.service';

@Component({
  selector: 'pps-user-profile',
  templateUrl: './user-profile.component.html',
  styles: [
  ],
})
export class UserProfileComponent implements OnInit, OnDestroy {
  private subs = new SubSink();

  updateAccountViewModel: UpdateAccountViewModel = null;
  updatePasswordViewModel: UpdatePasswordViewModel = null;
  section: string = "profile";
  updating: boolean = false;
  errorMessage: string = "";
  smallScreen: boolean = false;

  constructor(private _authService: AuthenticationService,
              private _accountService: AccountService,
              private _toast: ToastService,
              private _route: ActivatedRoute,
              private breakpointObserver: BreakpointObserver) {
    this.subs.sink = this.breakpointObserver.observe(['(min-width: 768px)'])
      .subscribe((state: BreakpointState) => {
        this.smallScreen = !state.matches;
      });    

    this.subs.sink = this._route.queryParams.subscribe(param => {
      this.section = param.section || "profile";
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  ngOnInit(): void {
    this.init();
  }

  init(){
    this.updateAccountViewModel = {
      clientUserId: this._authService.userContext.zoesenUser.id,
      zoesenUserId: this._authService.userContext.zoesenUser.zoesenUserId,
      userName: this._authService.userContext.zoesenUser.zoesenUsername,
      firstName: this._authService.userContext.zoesenUser.firstName,
      lastName: this._authService.userContext.zoesenUser.lastName,
      email: this._authService.userContext.zoesenUser.email,
      //phoneNumber: this._authService.userContext.zoesenUser.phoneNumber,
      avatar: this._authService.userContext.zoesenUser.avatar
    };

    this.updatePasswordViewModel = {
      clientUserId: this._authService.userContext.zoesenUser.id,
      zoesenUserId: this._authService.userContext.zoesenUser.zoesenUserId,
      userName: this._authService.userContext.zoesenUser.zoesenUsername
    };
  }

  canManageProfile(): boolean{
    return this._authService.canUserDoAnyOfTheOperartions([
      BusinessOperation.ManageOwnProfile,
      BusinessOperation.ManageAllAccount
    ]);
  }

  canManagePassword(): boolean{
    return this._authService.canUserDoAnyOfTheOperartions([
      BusinessOperation.ManageOwnPassword,
      BusinessOperation.ManageAllAccount
    ]);
  }

  updateUserProfile(profileForm){
    if (profileForm.invalid){
      return;
    }

    this.updating = true;
    this.subs.sink = this._accountService.update(this.updateAccountViewModel)
      .subscribe(res => {
        if (res.succeed){
          this._authService.setUserProfile(this.updateAccountViewModel);
          this._toast.succeeded("Your profile has been successfully updated.");
        }else{
          this._toast.failed(`Failed to update your profile: ${res.errors.join(";")}`);
        }
      })
      .add(()=>{
        this.updating = false;
      });;
  }

  updateCred(credForm: NgForm){
    if (this.updatePasswordViewModel.newPassword !== this.updatePasswordViewModel.confirmPassword){
      credForm.controls["confirmPassword"].setErrors({"notmatch": true});
      return;
    }

    if (this.updatePasswordViewModel.newPassword){
      if (!/(?=.*[a-z])/g.test(this.updatePasswordViewModel.newPassword)){
        credForm.controls["newPassword"].setErrors({"nolowercase": true});
        return;
      }

      if (!/(?=.*[A-Z])/g.test(this.updatePasswordViewModel.newPassword)){
        credForm.controls["newPassword"].setErrors({"nouppercase": true});
        return;
      }

      if (!/(?=.*\d)/g.test(this.updatePasswordViewModel.newPassword)){
        credForm.controls["newPassword"].setErrors({"nodigit": true});
        return;
      }

      if (!/(?=.*[-+_!@#$%^&*.,?])/g.test(this.updatePasswordViewModel.newPassword)){
        credForm.controls["newPassword"].setErrors({"nonalphanumeric": true});
        return;
      }
    }

    if (credForm.invalid){
      return;
    }
    
    this.updating = true;
    this.errorMessage = "";
    
    let acct = _.clone(this.updatePasswordViewModel);
    acct.newPassword = btoa(this.updatePasswordViewModel.newPassword);
    acct.confirmPassword = btoa(this.updatePasswordViewModel.confirmPassword);

    this.subs.sink = this._accountService.updatePassword(acct)
      .subscribe(res => {
        if (res.succeed){
          this._toast.succeeded("Your password has been successfully updated.");
        }else{
          this.errorMessage = `${res.errors.join(";")}`;
          //this._toast.failed(`Failed to update your password: ${res.errors.join(";")}`);
        }
      })
      .add(()=>{
        this.updating = false;
      });;
  }
}
